import React from "react";
import './ProcessSection.css';
import BackgroundDecoration from '../../components/BackgroundDecoration/BackgroundDecoration';

/**
 * ProcessSection - Sección para mostrar proceso paso a paso
 * Ideal para mostrar "Cómo funciona" o flujos de trabajo
 */
const ProcessSection = ({ title, subtitle, steps = [], theme = 'dark', backgroundDecoration }) => {
  return (
    <div className={`processContainer processContainer--${theme}`}>
      {backgroundDecoration && <BackgroundDecoration {...backgroundDecoration} />}
      {title && <h2 className="processTitle">{title.toUpperCase()}</h2>}
      {subtitle && <p className="processSubtitle">{subtitle}</p>}

      <div className="stepsContainer">
        {steps.map((step, index) => (
          <div className="stepCard" key={index}>
            <div className="stepNumber">{String(index + 1).padStart(2, '0')}</div>
            <div className="stepContent">
              {step.icon && <div className="stepIcon">{step.icon}</div>}
              <h3 className="stepTitle">{step.title.toUpperCase()}</h3>
              <p className="stepDescription">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessSection;
